import { VinkIcoon } from '@/components/layout/Iconen';
import './form.css';

export interface SectieStand {
  nummer: number;
  titel: string;
  ingevuld: boolean;
}

interface SectieTrapProps {
  secties: SectieStand[];
}

/**
 * De acht secties als trap, in de marge naast de leeskolom.
 *
 * Alleen op een tablet in portret. Daar staat de inhoud in een kolom van
 * 640 px met bijna honderd pixels marge aan weerszijden; die ruimte laten
 * leeghangen is zonde, en dit is precies wat er in past.
 *
 * Twee dingen tegelijk: je ziet hoe ver je bent zonder te scrollen, en je
 * springt met één tik naar een sectie in plaats van er langs te scrollen.
 */
export function SectieTrap({ secties }: SectieTrapProps): JSX.Element {
  const klaar = secties.filter((s) => s.ingevuld).length;

  const springNaar = (nummer: number) => {
    const doel = document.getElementById(`sectie-${nummer}`);
    doel?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav className="sectietrap" aria-label="Onderdelen van dit formulier">
      {secties.map((sectie) => (
        <button
          key={sectie.nummer}
          type="button"
          className={`sectietrap__stap${sectie.ingevuld ? ' sectietrap__stap--ingevuld' : ''}`}
          onClick={() => springNaar(sectie.nummer)}
          title={sectie.titel}
          aria-label={`${sectie.titel}${sectie.ingevuld ? ', ingevuld' : ', nog leeg'}`}
        >
          {sectie.ingevuld ? <VinkIcoon /> : sectie.nummer}
        </button>
      ))}

      <span className="sectietrap__stand">
        {klaar}/{secties.length}
      </span>
    </nav>
  );
}
